import Config from './config';

function Cache (){
  this.set = (key, value) => {
    return window.localStorage.setItem(Config.CACHE_KEY_PREFIX + key, value);
  }
  
  this.get = (key, defaultValue) => {
    let r = window.localStorage.getItem(Config.CACHE_KEY_PREFIX + key);
    if (r) {
      return r;
    } else {
      return defaultValue;
    }
  }
}
let cache = new Cache();
export default cache;


// WEBPACK FOOTER //
// ./src/components/utils/cache.js